import { microphoneError, readBands } from "~/lib/audio";
import type { NodeDefinition } from "~/nodes/types";

const BANDS = ["level", "lows", "mids", "highs"] as const;

export const audioNode: NodeDefinition = {
  type: "audio",
  label: "Audio",
  category: "Input",
  inputs: [],
  outputs: [
    { key: "level", label: "Level", socket: "number" },
    { key: "lows", label: "Lows", socket: "number" },
    { key: "mids", label: "Mids", socket: "number" },
    { key: "highs", label: "Highs", socket: "number" },
  ],
  controls: BANDS.map((band) => ({
    kind: "preview" as const,
    key: band,
    label: band,
  })),
  defaults: {},

  compute(ctx) {
    const error = microphoneError();
    if (error) ctx.fail("level", error);

    const bands = readBands();
    for (const band of BANDS) ctx.preview(band, bands[band]);

    return { ...bands };
  },
};
